#= require ./select2_collection_input

class KCVS.Select2RemoteCollectionInput extends KCVS.Select2CollectionInput
  constructor: ->
    super
    value = @input.data('value')
    if value
      if typeof(value) == 'object' && value.length # Means that input is for tags
        for val in value
          option = "<option value='#{val}' selected>#{val}</option>"
          @input.append(option)
      else
        text = @input.data('text-value') || ""
        option = "<option value='#{value}' selected>#{text}</option>"
        @input.append(option)
      @input.trigger("change")

  selectOptions: ->
    $.extend {}, super, {
      placeholder: @input.data('placeholder') || ' '
      ajax: @ajax()
      formatResult: _.bind(@formatResult, @)
    }

  ajax: ->
    url: @input.data('url')
    dataType: 'json'
    delay: 250
    data: (query, page) =>
      data = { q: query }
      if queryParam = @input.data 'query-param'
        data = { q: {} }
        data.q[queryParam] = query
      else
        data = { q: query }
      container = @input.data('additional-params-container')
      $container = if container then @input.closest(container) else null
      for param, field of @input.data('additional-params')
        try
          $field = if container then $container.find(field) else $(field)
          data[param] = $field.val()
          throw e if $field.length < 1
        catch error
          data[param] = field
      data

    processResults: (resources, page) =>
      textName  = @input.data('text-name')
      valueName = @input.data('value-name') || 'id'
      for resource in resources
        resource.id   = Helper.escapeString(resource[valueName])
        resource.text = Helper.escapeString(resource[textName])
      { results: resources }

  formatNoMatches: ->
    linkTitle   = @input.data('formatNoMatchesLinkTitle')
    linkClass   = @input.data('formatNoMatchesLinkClass')
    linkHref    = @input.data('formatNoMatchesLinkHref')
    linkTarget  = @input.data('formatNoMatchesLinkTarget')
    if linkHref && linkTitle
      linkOnClick = "window.open(\"#{linkHref}\", \"#{linkTarget}\");$(\"##{@input.attr('id')}\").select2(\"close\");"
      "<a class='#{linkClass}' onclick='#{linkOnClick}'>#{linkTitle}</a>"
    else
      I18n.t("select2.messages.no_matches")

  formatResult: (resource) ->
    textName = @input.data('text-name')
    Helper.escapeString(resource[textName])


$ ->
  $('select.select2_remote_collection').each ->
    new KCVS.Select2RemoteCollectionInput(this)
